import React from "react";

import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

// Custom Styles
import "./cardSection.styles.scss";

function CardSection(props) {
  const stripe = useStripe();
  const elements = useElements();



  return (
    <div>
      <fieldset style={{ border: "none" }}>
        <div className="form-row">
          <div id="card-element">
            <CardElement
              options={{
                style: {
                  base: {
                    fontSize: "18px",
                    color: "#424770",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                  invalid: {
                    color: "#9e2146",
                  },
                },
                hidePostalCode: false,
                onChange: (event) => {
                  if (props.onCardChange) {
                    props.onCardChange(event);
                  }
                },
              }}
            />
          </div>
          {props.stripeError ? <div>{props.stripeError.toString()}</div> : null}
          <div id="card-errors" role="alert" />
        </div>
      </fieldset>
    </div>
  );
}
export default CardSection;
